import React from 'react'

function SchedulePerDay(props) {
    const { day, date, timing ,maxtiming} = props
    let dash=[]
    for (let i = 0; i < maxtiming - timing.length; i++) {
        dash.push(i)
    }
    return (
        <div className="col-md-1 mx-2 d-flex flex-column" >
            <div className="py-2 h6 d-flex flex-column align-items-center   ">
                <div className="white-2 mb-1">{day}</div>
                <div className="white-1">{date}</div>
            </div>
            <div className="d-flex flex-column align-items-center ">
                {timing.length!==0 && timing.map((time) => {
                    return <p className="px-3 py-1  rounded timeSlot">{time}</p>
                })}
                {dash.map(()=>{
                    return <p className="white-3 h5 px-3 py-2">-</p>
                })}
            </div>
        </div>
    )
}

export default SchedulePerDay